<template>
  <store-provider>
    <template v-slot:default="{ $storeProviderData }">
      <bermuda-columns
        v-if="$storeProviderData.rootCategories.length"
        class="is-marginless"
      >
        <template slot="A">
          <categories-list />
        </template>
        <template slot="B">
          <products-list-wrapper v-if="$storeProviderData.selectedCategory" />
        </template>
      </bermuda-columns>

      <u-message
        v-else
        class="has-margin-x-100"
        icon="info-circle"
        type="is-dark"
        :title="$t('_.no_available_products')"
        >{{
          isAdmin
            ? $t("_sentence.no_sellable_products_admin")
            : $t("_sentence.no_sellable_products_client")
        }}
      </u-message>
    </template>
  </store-provider>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Context from "@/mixins/context";

export default defineComponent({
  name: "ShopView",
  components: {
    "store-provider": () =>
      import("@/components/app/global/baskets/basket/shop/storeProvider.vue"),
    "categories-list": () =>
      import("@/components/app/global/baskets/basket/shop/categoriesList.vue"),
    "products-list-wrapper": () =>
      import(
        "@/components/app/global/baskets/basket/shop/productsListWrapper.vue"
      )
  },
  mixins: [Context]
});
</script>
